'use client';

import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface HeaderSlotContextValue {
  centerSlot: ReactNode;
  setCenterSlot: (slot: ReactNode) => void;
}

const HeaderSlotContext = createContext<HeaderSlotContextValue>({
  centerSlot: null,
  setCenterSlot: () => {},
});

export function HeaderSlotProvider({ children }: { children: ReactNode }) {
  const [centerSlot, setCenterSlotState] = useState<ReactNode>(null);

  const setCenterSlot = useCallback((slot: ReactNode) => {
    setCenterSlotState(slot);
  }, []);

  return (
    <HeaderSlotContext.Provider value={{ centerSlot, setCenterSlot }}>
      {children}
    </HeaderSlotContext.Provider>
  );
}

export function useHeaderSlot() {
  return useContext(HeaderSlotContext);
}
